import React from "react";
import "./project.css";
import Netflix from "../../assets/Netflix-Api.png";
import Icasve from "../../assets/icasve.jpeg";
import Smartgrowth from "../../assets/smart_growth.jpeg";

const Project = () => {
  return (
    <section className="project" id="project">
      <div className="container-default">
        <h2 className="section__title">Projects</h2>
        <span className="section__subtitle">
          Here are a few projects I've worked on recently. 🧩
        </span>
        <div className="project__content grid">
          <div className="project__section">
            <img src={Icasve} alt="" className="project__img" />
            <div className="project__transition">
              <div className="project__deskription">
                <h4>ICASVE</h4>
                <p>
                  nternational Conference on Entrepreneurship, Innovation and
                  Creativity aims to bring together leading academic.
                </p>
              </div>
              <div className="project__tech">
                <div className="platform">
                  <p className="platform__title">Web</p>
                  <p className="platform__subtitle">Platform based</p>
                </div>
                <div className="stack">
                  <p className="platform__title">Laravel</p>
                  <p className="platform__subtitle">Tech stack</p>
                </div>
              </div>
            </div>
          </div>

          <div className="project__section">
            <img src={Smartgrowth} alt="" className="project__img" />
            <div className="project__transition">
              <div className="project__deskription">
                <h4>SmartGrowth</h4>
                <p>
                  SmartGrowth is an AI-based stunting calculator application
                  that predicts children's healthy growth using machine
                  learning.
                </p>
              </div>
              <div className="project__tech">
                <div className="platform">
                  <p className="platform__title">Web</p>
                  <p className="platform__subtitle">Platform based</p>
                </div>
                <div className="stack">
                  <p className="platform__title">CodeIgniter</p>
                  <p className="platform__subtitle">Tech stack</p>
                </div>
              </div>
            </div>
          </div>

          <div className="project__section">
            <img src={Netflix} alt="" className="project__img" />
            <div className="project__transition">
              <div className="project__deskription">
                <h4>Netflix-Api</h4>
                <p>
                  Netflix-APi project exercises using react based on themoviedb
                  API.
                </p>
              </div>
              <div className="project__tech">
                <div className="platform">
                  <p className="platform__title">Web</p>
                  <p className="platform__subtitle">Platform based</p>
                </div>
                <div className="stack">
                  <p className="platform__title">React</p>
                  <p className="platform__subtitle">Tech stack</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Project;
